import React from 'react';
import ForgotPassword from './ForgotPassword';

export default function SellerForgotPassword() {
  return <ForgotPassword forceRole="seller" />;
}

